/**
 * Shrine / theme sometimes leaves document.body with .overflow-hidden after the cart drawer closes.
 * When <cart-drawer> is not .active, strip that class from body.
 */
(function () {
  if (window.__cartDrawerBodyScrollFixInstalled) return;
  window.__cartDrawerBodyScrollFixInstalled = true;

  var observed = null;
  var attrObserver = null;

  function unlockBodyIfDrawerClosed() {
    var drawer = document.querySelector('cart-drawer.drawer');
    if (!drawer || !drawer.classList.contains('active')) {
      document.body.classList.remove('overflow-hidden');
    }
  }

  function bindDrawer(drawer) {
    if (!drawer) return;
    if (drawer === observed) {
      unlockBodyIfDrawerClosed();
      return;
    }

    if (attrObserver) {
      attrObserver.disconnect();
      attrObserver = null;
    }

    observed = drawer;

    attrObserver = new MutationObserver(function () {
      unlockBodyIfDrawerClosed();
    });
    attrObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    unlockBodyIfDrawerClosed();
  }

  function sync() {
    var drawer = document.querySelector('cart-drawer.drawer');
    if (drawer !== observed) {
      bindDrawer(drawer);
    } else if (!drawer) {
      if (attrObserver) {
        attrObserver.disconnect();
        attrObserver = null;
      }
      observed = null;
      document.body.classList.remove('overflow-hidden');
    }
  }

  document.addEventListener('DOMContentLoaded', sync);

  new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });

  window.addEventListener(
    'cart-drawer:close',
    function () {
      requestAnimationFrame(unlockBodyIfDrawerClosed);
    },
    true
  );
})();
